<div class="container">
  <p-floatLabel>
    <input pInputText id="presetName" [(ngModel)]="presetName" />
    <label for="presetName">Preset Name</label>
  </p-floatLabel>
</div>
<div class="bottom">
  <p-button label="Cancel" severity="secondary" (onClick)="closeDialog()"></p-button>
  <p-button label="Create Preset" severity="primary" (onClick)="createPreset()"></p-button>
</div>
